import { downloadBlob } from './download-blob';

/**
 * Saves `text` as a file — same approach as the render preview's PNG download (`render-preview-modal.tsx`).
 */
export function downloadTextFile(text: string, fileName: string, mime = 'application/json'): void {
  downloadBlob(new Blob([text], { type: `${mime};charset=utf-8` }), fileName);
}
